import React, { Component } from 'react';
import 'whatwg-fetch'

import "./FormBody.scss"
import "../../static/css/font-awesome/scss/font-awesome.scss"

import dataJSON from "../../api/data.json"

import FormHeader from "./FormHeader"
import FormFooter from "./FormFooter"

class FormBody extends Component {
  constructor() {
    super();
    this.handleInputChange = this.handleInputChange.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
    this.state = {
      AcceptedTakanon: 0,
      alReadySent: false,
      taknonValue: 0,
      messageBox: {
        showMessage: false
      }
    }
  }
  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      [event.target.name + "_error"]: {
        border: "1px solid black"
      }
    });
    if (event.target.name == "AcceptedTakanon") {
      this.setState({
        [event.target.name]: (this.state.taknonValue == 0 ? 1 : 0),
        taknonValue: (this.state.AcceptedTakanon == 0 ? 1 : 0)
      });
    }
  }
  sendForm() {
    if (!this.state.FullName) {
      this.setState({
        FullName_error: {
          border: "1px solid red"
        }
      })
      window.document.getElementById("FullName").focus();
      return false;
    }
    if (!this.state.Age) {
      this.setState({
       Age_error: {
          border: "1px solid red"
        }
      })
      window.document.getElementById("Age").focus();
      return false;
    }
    if (this.state.Age <= 0 || this.state.Age >= 100) {
      this.setState({
        Age_error: {
          border: "1px solid red"
        }
      })
      window.document.getElementById("Age").focus();
      return false;
    }
    if (!this.state.Phone) {
      this.setState({
       Phone_error: {
          border: "1px solid red"
        }
      })
      window.document.getElementById("Phone").focus();
      return false;
    }
    if (this.state.Phone.length < 7 || this.state.Phone.length >= 17) {
      this.setState({
        Phone_error: {
          border: "1px solid red"
        }
      })
      window.document.getElementById("Phone").focus();
      return false;
    }
    if (!this.state.Email) {
      this.setState({
        Email_error: {
          border: "1px solid red"
        }
      })
      window.document.getElementById("Email").focus();
      return false;
    }
    if (this.state.Email.indexOf("@") < 0 ||
      this.state.Email.indexOf(".") < 0) {
      this.setState({
        Email_error: {
          border: "1px solid red"
        }
      })
      window.document.getElementById("Email").focus();
      return false;
    }
    if (!this.state.MyDilemmaDesc) {
      this.setState({
        MyDilemmaDesc_error: {
          border: "1px solid red"
        }
      })
      window.document.getElementById("MyDilemmaDesc").focus();
      return false;
    }
    if (this.state.AcceptedTakanon != 1) {
      this.setState({
        messageBox: {
          showMessage: true,
          message: "נא לאשר את התקנון"
        }
      })
      return false;
    }

    // var apiURL = "http://localhost:51066/"; // DEV
    // var apiURL = "http://source-qa.a.ynet.co.il/mShort/commerce/2018/MyDilemma/"; // QA
    var apiURL = "https://z.ynet.co.il/mShort/commerce/2018/MyDilemmaAPI/"; // PROD

    if(this.state.alReadySent) {
      return false;
    }
    window.scrollTo(0,0);
    this.setState({
      isLoaderBarON: true,
      alReadySent: true
    })
    fetch(`${apiURL}api/articles/add/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        FullName: this.state.FullName,
        Email: this.state.Email,
        Age: this.state.Age,
        Phone: this.state.Phone,
        MyDilemmaDesc: this.state.MyDilemmaDesc,
        AcceptedTakanon: this.state.AcceptedTakanon,
      })
    }).then(data => {
      window.setTimeout(() => {
        this.setState({
          isLoaderBarON: false,
          alReadySent: false,
          messageBox: {
            showMessage: true,
            message: "הפרטים נשלחו בהצלחה"
          }
        })
      }, 250);
    });
  }
  closePopUp() {
    this.setState({
      messageBox: {
        showMessage: false,
        message: ""
      }
    })
  }
  render() {
    return (
      <div className="smallscreens">
        <div id="errorMessage" style={{ display: (this.state.messageBox.showMessage ? "block" : "none") }}>
          <div className="errorarea">
            <div className="message">
              <div className="padding">
                {this.state.messageBox.message}
              </div>
              <div className="close" onClick={this.closePopUp}>
                <i className="fa fa-times-circle fa-2x" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
        <div id="loadbar" style={{ display: (this.state.isLoaderBarON ? "block" : "none") }}>
          <div className="loaderarea">
            <div className="loader"></div>
          </div>
        </div>
        <FormHeader data={dataJSON.formbody.header} />
        <div className="linepoint"></div>
        <section className="section section-body">
          <div className="container">
            <form method="post" encType="multipart/form-data" id="form1" name="form1" onSubmit={this.preventSubmit}>
              <div className="row">
                <div className="item">
                  <input type="text" className="input name" style={this.state.FullName_error} name="FullName" placeholder={dataJSON.formbody.form.FullName} id="FullName" onLoad={this.handleInputChange} onChange={this.handleInputChange} />
                </div>
                <div className="item">
                  <input type="number" className="input age" style={this.state.Age_error} min="0" max="100" name="Age" placeholder={dataJSON.formbody.form.Age} id="Age" onLoad={this.handleInputChange} onChange={this.handleInputChange} />
                </div>
              </div>
              <div className="row">
                <div className="item">
                  <input type="tel" className="input" style={this.state.Phone_error} name="Phone" placeholder={dataJSON.formbody.form.Phone} id="Phone" onLoad={this.handleInputChange} onLoad={this.handleInputChange} onChange={this.handleInputChange} />
                </div>
              </div>
              <div className="row">
                <div className="item">
                  <input type="email" className="input" style={this.state.Email_error} name="Email" placeholder={dataJSON.formbody.form.Email} id="Email" onLoad={this.handleInputChange} onChange={this.handleInputChange} />
                </div>
              </div>
              <div className="row textarea">
                <div className="item">
                  <textarea name="MyDilemmaDesc" style={this.state.MyDilemmaDesc_error} placeholder={dataJSON.formbody.form.MyDilemmaDesc} id="MyDilemmaDesc" onLoad={this.handleInputChange} onChange={this.handleInputChange}></textarea>
                </div>
              </div>
            </form>
            <FormFooter sendForm={this.sendForm} taknonValue={this.state.taknonValue} handleInputChange={this.handleInputChange} data={dataJSON.formbody.form} />
          </div>
        </section>
      </div>
    );
  }
}

export default FormBody;



// WEBPACK FOOTER //
// ./src/Components/FormBody/FormBody.js